module.exports = __webpack_public_path__ + "media/images/icon__minus@2x-85345122af7ab64cced54d4bdd3563b4.png";